'use client';

import React, { useEffect, useRef } from 'react';

export default function AboutHero() {
  const heroRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const el = heroRef.current;
    if (!el) return;
    const items = el.querySelectorAll('.hero-item');
    items.forEach((item, i) => {
      setTimeout(() => {
        (item as HTMLElement).style.opacity = '1';
        (item as HTMLElement).style.transform = 'translateY(0)';
      }, 0 + i * 80);
    });
  }, []);

  return (
    <section data-component-id="src/app/about/components/AboutHero.tsx:21:4" data-component-path="src/app/about/components/AboutHero.tsx" data-component-line="21" data-component-end-line="78" data-component-file="AboutHero.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22relative%20overflow-hidden%22%7D"
      ref={heroRef}
      className="relative overflow-hidden"
      style={{
        background: '#000000',
        paddingTop: '120px',
        paddingBottom: '80px',
        borderBottom: '1px solid rgba(255,255,255,0.06)',
      }}
    >
      <div data-component-id="src/app/about/components/AboutHero.tsx:31:6" data-component-path="src/app/about/components/AboutHero.tsx" data-component-line="31" data-component-end-line="34" data-component-file="AboutHero.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20pointer-events-none%22%7D"
        className="absolute inset-0 pointer-events-none"
        style={{ background: 'linear-gradient(135deg, rgba(198,0,0,0.06) 0%, transparent 60%)' }}
      />
      <div data-component-id="src/app/about/components/AboutHero.tsx:35:6" data-component-path="src/app/about/components/AboutHero.tsx" data-component-line="35" data-component-end-line="77" data-component-file="AboutHero.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-container%20mx-auto%20px-4%20sm%3Apx-6%20lg%3Apx-8%20relative%20z-10%22%7D" className="max-w-container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div data-component-id="src/app/about/components/AboutHero.tsx:36:8" data-component-path="src/app/about/components/AboutHero.tsx" data-component-line="36" data-component-end-line="41" data-component-file="AboutHero.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22hero-item%22%7D"
          className="hero-item"
          style={{ opacity: 0, transform: 'translateY(20px)', transition: 'all 0.4s cubic-bezier(0.16,1,0.3,1)' }}
        >
          <p data-component-id="src/app/about/components/AboutHero.tsx:40:10" data-component-path="src/app/about/components/AboutHero.tsx" data-component-line="40" data-component-end-line="40" data-component-file="AboutHero.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22section-label%22%2C%22textContent%22%3A%22About%20Us%22%7D" className="section-label">About Us</p>
        </div>
        <h1 data-component-id="src/app/about/components/AboutHero.tsx:42:8" data-component-path="src/app/about/components/AboutHero.tsx" data-component-line="42" data-component-end-line="60" data-component-file="AboutHero.tsx" data-component-name="h1" data-component-content="%7B%22elementName%22%3A%22h1%22%2C%22className%22%3A%22hero-item%20font-heading%20mb-5%22%2C%22textContent%22%3A%22Addis%20Ababa's%20Trusted%20%20%20%20%20Diagnostic%20Center%22%7D"
          className="hero-item font-heading mb-5"
          style={{
            opacity: 0,
            transform: 'translateY(20px)',
            transition: 'all 0.4s cubic-bezier(0.16,1,0.3,1)',
            fontSize: 'clamp(32px, 5vw, 60px)',
            color: '#f7f8fd',
            fontFamily: 'Manrope, sans-serif',
            fontWeight: 800,
            letterSpacing: '-0.03em',
            lineHeight: 1.05,
            maxWidth: '700px',
          }}
        >
          Addis Ababa's Trusted{' '}
          <span data-component-id="src/app/about/components/AboutHero.tsx:58:10" data-component-path="src/app/about/components/AboutHero.tsx" data-component-line="58" data-component-end-line="58" data-component-file="AboutHero.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22textContent%22%3A%22Automotive%22%7D" style={{ color: '#c60000' }}>Automotive</span>{' '}
          Diagnostic Center
        </h1>
        <p data-component-id="src/app/about/components/AboutHero.tsx:61:8" data-component-path="src/app/about/components/AboutHero.tsx" data-component-line="61" data-component-end-line="76" data-component-file="AboutHero.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22hero-item%22%2C%22textContent%22%3A%22Tehetna%20Diagnostic%20Garage%20is%20dedicated%20to%20providing%20accurate%20diagnostics%2C%20professional%20repairs%2C%5Cn%20%20%20%20%20%20%20%20%20%20and%20reliable%20automotive%20care%20for%20Ethiopian%20drivers%20%E2%80%94%20with%20honesty%2C%20skill%2C%20and%20modern%20technology.%22%7D"
          className="hero-item"
          style={{
            opacity: 0,
            transform: 'translateY(20px)',
            transition: 'all 0.4s cubic-bezier(0.16,1,0.3,1)',
            color: '#888888',
            fontSize: 'clamp(14px, 2vw, 17px)',
            lineHeight: 1.8,
            maxWidth: '580px',
            fontFamily: 'DM Sans, sans-serif',
          }}
        >
          Tehetna Diagnostic Garage is dedicated to providing accurate diagnostics, professional repairs,
          and reliable automotive care for Ethiopian drivers — with honesty, skill, and modern technology.
        </p>
      </div>
    </section>
  );
}